<template>
<Popup v-model="tosOpen">
    <template #content>
        <div id="tos_popup">
            <div class="inner">
                <h3 v-text="get_word('tos_title', true)"></h3>
                <div class="tos_content">
                    <QuillEditor
                        v-model:content="tosContent"
                        contentType="html"
                        theme="snow"
                        :toolbar="false"
                        :readOnly="true"
                        :options="editorOptions"
                    />
                </div>
                <SignupForm 
                    v-if="!hasSigned" 
                    @signup="hasSigned = true" 
                    @show-page="show_page = $event"
                    @show-terms="alert(get_word('terms_content'))"
                />
                <div class="signature_container">
                    <h4>חתימה</h4>
                    <SignaturePad :width="350" :height="150"  @input="singChange" :customStyle="sigPadStyle" ref="signaturePad"></SignaturePad>
                </div>
                
                <div class="terms-acceptance">
                    <label class="checkbox-container">
                        <input type="checkbox" v-model="termsAccepted">
                        <span class="checkmark"></span>
                        <span class="label-text">קראתי ואני מסכים/ה לתנאי עורך הדין</span>
                    </label>
                </div>
            </div>
        </div>
    </template>
    <template #actions>
        <a class="md-primary" :class="{ disabled: (!termsAccepted || !isOkToSubmit) }" @click="termsAccepted && isOkToSubmit && tosApprove()">אישור</a> 
        <a class="md-primary" @click="tosOpen = false">סגירה</a> 
    </template>
</Popup>
<li class="project_container " :class="{open: moreDetailsOpen, [item.apply_status]: true}" @click="applyPrj(item)">
    <span class="apply_status" v-text="get_word('prj_status_' + item.apply_status, true)"></span>
    <div class="details_pic_container">
        <div v-if="item.close_time" class="time_left">
            <span v-text="item.close_time"></span>
            <span>שעות לסגירת המכרז</span>
        </div>
        <div class="right">
            <div class="pic" :style="bg(item.user_pic_parsed)"></div>
            <div class="text">
                <p>יוזם מכרז</p>
                <h4 v-text="item.user_name"></h4>
            </div>
            <div class="prj_number_item">
                <h5>מספר פרויקט {{  item.prj_number }}</h5>
            </div>
        </div>
        <ul class="details">
            <li class="data_container" v-if="item.is_file_opened_in_administration === '1'">
                <h5>נפתח תיק במנהלת</h5>
                <div><span v-if="item.is_file_opened_in_administration === '1'"><i class="fas fa-check"></i></span> <span v-else><i class="fas fa-times"></i></span></div>
            </li>
            <li class="data_container" v-if="item.is_supervisor_in_project === '1'">
                <h5>מפקח בפרויקט</h5>
                <div><span v-if="item.is_supervisor_in_project === '1'"><i class="fas fa-check"></i></span> <span v-else><i class="fas fa-times"></i></span></div>
            </li>
            <li class="data_container" v-if="item.is_shamay === '1'">
                <h5>שמאי בפרויקט</h5>
                <div><span v-if="item.is_shamay"><i class="fas fa-check"></i></span> <span v-else><i class="fas fa-times"></i></span></div>
            </li>
            <li class="data_container">
                <h5>סטטוס</h5>
                <div v-text="item.status_parse"></div>
            </li>
            <li class="data_container">
                <h5>כתובת</h5>
                <div>
                    <!-- <span v-for="(bld, i) in item.buildings" :key="bld.id" ><a class="underline" v-text="bld.street + ' ' + bld.num_street"></a> <span v-if="i+1 < item.num_buildings">, </span></span>
                    <span class="city" v-text="', '+item.city"></span> -->
                    <a class="underline" v-text="item.name"></a>
                </div>
            </li>
            <li class="data_container">
                <h5>מס' בניינים</h5>
                <div v-text="item.num_building"></div>
            </li>
            <li class="data_container">
                <h5>יחידות קיימות</h5>
                <div >
                    <span v-text="item.num_apartments"></span>
                    <div class="icon_container" @click="moreDetailsOpen=!moreDetailsOpen">
                        <div class="icon arrow_bottom_icon" :class="moreDetailsOpen ? 'rotate' : ''"></div>
                    </div>
                </div>
            </li>
    
            <li class="data_container">
                <h5>סוג הפרויקט</h5>
                <div v-if="item.num_building == '1'">התחדשות בניינית</div>
                <div v-else>התחדשות מתחמית</div>
            </li>
        </ul>
        <div class="last_details_btn_container">
            <div v-if="item.is_close_72 && item.apply_status == 'no_apply'" class="tag" :class="{tut: false}">
                    <p >
                        <strong>72</strong>
                        שעות לסגירת המכרז  
                    </p>    
                </div>
            <li class="data_container">
                <h5>מועד סיום המכרז</h5>
                <div v-text="item.date_end"></div>
            </li>
            <li>
                <div class="full_details_btn" @click="applyPrj(item)" :class="item.bid_step">
                    <span v-text="item.bid_step === 'improve' ? 'לשיפור הצעות סבב ב' : 'לפרטים המלאים והגשת מועמדות'"></span>
                    <span class="arrow_up_left_icon"></span>
                </div>
            </li>
        </div>
    </div>
    <div class="more_details">
        <div class="data">
            <h4>פירוט סוגי היחידות</h4>
            <ul>
                <template v-for="unit in item.units_details" :key="unit.type">
                    <li v-if="+unit.count > 0">
                        <span v-text="unit.count"></span>
                        <span v-text="' - '+unit.name"></span>
                    </li>
                </template>
            </ul>
        </div>
        <!-- <div class="icon close_icon"  @click="moreDetailsOpen=!moreDetailsOpen"></div> -->
    </div>

</li>
</template>

<script>
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { QuillEditor } from '@vueup/vue-quill';

export default {
    components: {
        QuillEditor
    },
    props: ["item"],
    data() {
        return {
            moreDetailsOpen: true,
            sigPadStyle: {border: '#757F8C 1px solid', marginTop: '10px' ,marginBottom: '20px', borderRadius:'20px', width:'350px',},
            isOkToSubmit: false,
            tosOpen: false,
            tosContent: "",
            termsAccepted: false,
            editorOptions: {
                direction: 'rtl',
                readOnly: true,
                modules: {
                    toolbar: false
                }
            }
        }
    },
    methods: {
        singChange() {
            this.isOkToSubmit = true;
        },
        applyPrj(prj) {
            // if (prj.apply_status == 'no_apply') {
                this.tosOpen = true;
                this.tosContent = prj.lawyer_terms;
            // } else {
            //     this.$router.push({ name: 'applying_project', params: { token: this.item.token, step: 1 }})
            // }

        },
        tosApprove() {
            if(!this.isOkToSubmit)
            {
                this.alert('נא לחתום במקום המתאים') 
                return;
            }
            let form = {
                token: this.item.token,
                signature: this.signature,
            }
            const { data } = this.$refs.signaturePad.saveSignature();
            form.signature = data;
            this.api({ action: 'applying/save_bid',data: form } ,(data) => {
                if(data.data){
                    this.tosOpen = false;
                    this.$router.push({ name: 'applying_project', params: { token: this.item.token, step: 1 }})
                } else { alert('נכשל נסו מאוחר יותר'); this.tosOpen = false; }
            });
        },
    }
}

</script>

<style >
#popup_content { border-top-color: var(--color2) !important;}

</style>
<style lang="scss" scoped>

#tos_popup {
    .inner {
        padding: 20px;
        h3 { font-size: 24px; color: var(--dark_blue); font-weight: 600; margin-bottom: 20px;}
        .tos { font-size: 16px; color: var(--text_s); line-height: 1.6;}
    }

    .terms-acceptance {
        margin-top: 20px;
        padding: 10px 0;
        
        .checkbox-container {
            display: flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            user-select: none;
            
            input[type="checkbox"] {
                width: 18px;
                height: 18px;
                cursor: pointer;
            }

            .label-text {
                color: var(--dark_blue);
                font-size: 16px;
            }
        }
    }
}

.project_container { position: relative; display: flex; flex-direction: column;  background: #fff;  box-shadow: var(--box-shadow); border-radius: 40px; 
    &.open {
        .details_pic_container {  border-bottom: 1px solid var(--pageBG);}
        .more_details { max-height: 100px; padding: var(--gap_mid);  opacity: 1;
            .close_icon {  display: block;}
        }
    }
    &.paid, &.in_progress, &.complete { border: 2px solid var(--color2); 
        .apply_status { position: absolute; left: 38px; top: 0; border-bottom-right-radius: 12px; border-bottom-left-radius: 12px; background: var(--color2); padding: 2px 12px;}
    }

    .details_pic_container { display: flex; background: transparent; gap: 30px; padding: 8px;  }
    .more_details { opacity: 0; padding: 0px; max-height: 0px;  transition: 0.3s ease; display: flex; justify-content: center; align-items: center; position: relative; 
        .data {
            &, ul {display: flex; align-items: center; gap: var(--gap_mid); }
            h4 {     color: var(--text_s); font-weight: 400; }
            ul {
                li {
                    span { color: var(--dark_blue); }
                }
            }
        }
        .close_icon { cursor: pointer; display: none; position: absolute; left: var(--gap_mid); top: var(--gap_mid); }
    }
    // border: 1px solid var(--border_color);
    .time_left { position: absolute; top: 0%; left: 30px; transform: translateY(-50%); display: flex; gap: 5px; background: #D7D6FF; border-radius: 40px; padding: 8px 12px; font-size: 18px;}

    .right { border: 1px solid #E7F0F3; display: flex; flex-direction: column; justify-content: center; align-items: center; flex: 2; padding: 30px; background: var(--gray); gap: 16px; border-radius: 32px;
        .pic {width: 100%; aspect-ratio: 16/9;border-radius: 12px;background: #fff;background-repeat: no-repeat;background-position: center; background-size: contain;}
        .text { display: flex; flex-direction: column; 
            p {color: var(--text_s); font-size: var(--h5);}
            h4 {color: var(--dark_blue); font-size: var(--h5);}
        }
        .prj_number_item { display: flex; gap: 10px;    align-items: center;
                    h5 { color: var(--dark_blue);}
                    p { color: var(--text_s); font-size: var(--h6); line-height: 1;}
                }
    }
    .details { flex: 8;padding-block: 40px; position: relative; display: grid; grid-template-columns: repeat(4, 1fr);  gap: 50px;
        
    }
    .last_details_btn_container { position: relative; flex: 2; padding: 30px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;
        .tag {    position: absolute;
    top: calc((30px + 16px)* -1);
    transform: translateY(50%);}
        .full_details_btn { cursor: pointer;display: flex; gap: 5px; align-items: center; border-radius: var(--radius); border: 1px solid var(--text_s); padding: 10px 15px; box-shadow: var(--box-shadow); font-weight: 600; color: #333;
            &.improve { background-color: var(--color2); color: white; border-color: var(--color2);
                span { color: white; }
                .arrow_up_left_icon { filter: brightness(0) invert(1); }
            }
            span { color: var(--btn_color); line-height: 1.4;}
            .arrow_up_left_icon { display: block; background-image: url(../assets/arrow-up-left.svg); background-position: center center; width: 24px; height: 24px;}
        } 
    }
}

.md-primary.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-width:768px){
    .project_container {
        margin:20px 0;
    
    .details_pic_container {
    display: flex;
    flex-direction: column !important;
    background: transparent;
    gap: 30px;
    padding: 8px;

    .details{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    justify-items: stretch;
    align-items: stretch;
    align-self: center;
    width:80%;
    padding:10px 0 0 0;
    }
}
.last_details_btn_container{
    gap:10px;
    padding:10px;

    li{
        font-size: 18px;
        text-align: start;
        align-self: flex-start;
        justify-content: center;
        gap:10px;
        display: flex;
        flex-direction: row;
        width: 100%;
        
        
       
    }
}
}
}
</style>